//export const api_url = "http://localhost:5000";
export const api_url = "https://api.delivo.tn";